import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { VideoButton, mapPlaylistFromVideoSearch, styles } from 'yankees-react-utils';
import { useOktaQuery, Video } from '../data';
import { VideoPlayerModal } from './VideoPlayer';
import { store } from '../store';

const VideoPlayerButton = ({ modalContainer, text, color, textColor, showCameraIcon, icon, overrideAngleKey, onPlaylistSearchSuccess, ...videoparams }) => {
    const { state: { user } } = useContext(store);
    const [showVideoPlayer, setShowVideoPlayer] = useState(false);
    const { data: playlist } = useOktaQuery(
        ['videoSearch', videoparams],
        (t) => Video.search(t, videoparams),
        { enabled: showVideoPlayer, select: (resp) => mapPlaylistFromVideoSearch(resp, user.Roles.map((r) => r.RoleName)), onSuccess: onPlaylistSearchSuccess },
    );
    return (
        <>
            <VideoButton
                onClick={() => setShowVideoPlayer(true)}
                text={text}
                color={color}
                textColor={textColor}
                showCameraIcon={showCameraIcon}
                icon={icon || (videoparams.gameid && videoparams.eventseq && !videoparams.pitchseq ? 'AB' : undefined)}
                className={videoparams.className}
            />
            <VideoPlayerModal
                playlist={playlist}
                show={showVideoPlayer}
                onHide={() => setShowVideoPlayer(false)}
                container={modalContainer}
                overrideAngleKey={overrideAngleKey}
            />
        </>
    );
};

VideoPlayerButton.propTypes = {
    modalContainer: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    gameid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    eventseq: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pitchseq: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pitcherid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    batterid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fxpitchtype: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    islhb: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    text: PropTypes.string || PropTypes.number,
    icon: PropTypes.string,
    color: PropTypes.string,
    textColor: PropTypes.string,
    showCameraIcon: PropTypes.bool,
    overrideAngleKey: PropTypes.string,
    onPlaylistSearchSuccess: PropTypes.func,
};
VideoPlayerButton.defaultProps = {
    modalContainer: undefined,
    gameid: undefined,
    eventseq: undefined,
    pitchseq: undefined,
    pitcherid: undefined,
    batterid: undefined,
    fxpitchtype: undefined,
    islhb: undefined,
    text: undefined,
    icon: undefined,
    color: styles.theme.background.astronaut,
    textColor: undefined,
    showCameraIcon: undefined,
    overrideAngleKey: undefined,
    onPlaylistSearchSuccess: undefined,
};

export default VideoPlayerButton;
